// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2KwTu","file":"styles_file__2oWpg"};